import { render, staticRenderFns } from "./Produktübersicht.vue?vue&type=template&id=3f298319&scoped=true"
import script from "./Produktübersicht.vue?vue&type=script&lang=js"
export * from "./Produktübersicht.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f298319",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f298319')) {
      api.createRecord('3f298319', component.options)
    } else {
      api.reload('3f298319', component.options)
    }
    module.hot.accept("./Produktübersicht.vue?vue&type=template&id=3f298319&scoped=true", function () {
      api.rerender('3f298319', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Produktübersicht.vue"
export default component.exports